<div class="scorecard-description-sponsor sponsor-in-body" *ngIf="isSponsorInBody && hasSponsor">
  <fgbcl-scorecard-sponser-view [scorecard]="scorecardDescription.currentScorecard" />
</div>

<fgbcl-scorecard-description-linked-action
  [scorecardDescription]="scorecardDescription"
  (onNextClick)="nextClick()"
  (onPrevious)="previousClick()"
/>

<fgbcl-scorecard-description-actions [scorecardDescription]="scorecardDescription" />
